import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appEllipsisTitle]'
})
export class EllipsisTitleDirective {
  @Input('appEllipsisTitle') fullText: string = '';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    const element = this.el.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      this.renderer.setAttribute(element, 'title', this.fullText);
    } else {
      this.renderer.removeAttribute(element, 'title');
    }
  }
}
